// import Register from "./pages/auth/Register";
import Login from "./pages/auth/Login";
import Home from "./pages/home/Home";
import { Page } from "./pages/page/Page";
import axios from "axios";
import { useDispatch, useSelector } from "react-redux";
import { useEffect } from "react";
import { getLoginStatus, getUser } from "./redux/features/auth/authSlice";
import { ToastContainer } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";

import { BrowserRouter, Routes, Route } from "react-router-dom";
import Register from "./pages/auth/Register";
import NotFound from "./pages/404/NotFound";
import AdminOnlyRoute from "./components/hiddenLink/AdminOnlyRoute";
import Admin from "./pages/admin/Admin";
import NavbarTop from "./components/navbarTop/NavbarTop";
import Footer from "./components/footer/Footer";
import Profile from "./pages/profile/Profile";
import { getPosts } from "./redux/features/post/postSlice";
import MoveUp from "./components/moveUp/MoveUp";
import ReadLater from "./pages/readLater/ReadLater";
import Post from "./pages/search/Post";
import LoginOnlyRoute from "./components/hiddenLink/LoginOnlyRoute";
import PrivacyPolicy from "./components/privacyPolicy/PrivacyPolicy";
import TermsAndConditions from "./components/TermsAndConditions/TermsAndConditions";

function App() {
  axios.defaults.withCredentials = true;
  const { isLoggedIn, user } = useSelector((state) => state.auth);
  const dispatch = useDispatch();

  useEffect(() => {
    dispatch(getPosts());
  }, [dispatch]);

  useEffect(() => {
    dispatch(getLoginStatus());
  }, [dispatch]);

  useEffect(() => {
    if (isLoggedIn && user === null) {
      dispatch(getUser());
    }
  }, [dispatch, isLoggedIn, user]);

  return (
    <div className="App">
      <BrowserRouter>
        <ToastContainer
          // position="top-center"
          autoClose={3000}
          hideProgressBar={true}
          closeOnClick
          rtl={false}
          pauseOnFocusLoss
          draggable
          pauseOnHover
          theme="colored"
          style={{
            zIndex: 99999,
          }}
        />
        <NavbarTop />
        <Routes>
          <Route path="/" element={<Home />} />
          <Route path="/login" element={<Login />} />
          <Route path="/register" element={<Register />} />
          <Route path="/privacy-policy" element={<PrivacyPolicy />} />
          <Route path="/terms" element={<TermsAndConditions />} />

          <Route
            path="/profile"
            element={
              <LoginOnlyRoute>
                <Profile />
              </LoginOnlyRoute>
            }
          />
          <Route
            path="/readLater"
            element={
              <LoginOnlyRoute>
                <ReadLater />
              </LoginOnlyRoute>
            }
          />

          <Route path="/page/:identifier" element={<Page />} />
          <Route path="/search" element={<Post />} />

          <Route
            path="/admin/*"
            element={
              <AdminOnlyRoute>
                <Admin />
              </AdminOnlyRoute>
            }
          />
          <Route path="*" element={<NotFound />} />
        </Routes>
        <Footer />
      </BrowserRouter>

      <MoveUp />
    </div>
  );
}

export default App;
